/* eslint-disable @typescript-eslint/no-unused-vars */
import storeInfo from '../store'
import { TradeType } from './types'

export const getTradeTypes = (): TradeType[] => {
  const { tradeTypes } = storeInfo.store.getState()
  if (!tradeTypes || !tradeTypes.length) return []
  return tradeTypes
}
